import axios from 'axios'
import router from '@/router'
import { bus } from '@/main';
import appMixins from '@/mixins/global'

export default {
  state: {
    user: '',
    auth: {
        token: 'null',
    },
    loading: false,
    error: null,
  },
  mutations: {

    setUser(state, dataSignIn) {
        state.user = dataSignIn
    },

    setLoading(state, dataSignIn) {
        state.loading = dataSignIn
    },

    setError(state, dataSignIn) {
        state.error = dataSignIn
    },

    clearError(state) {
        state.error = null
    },

  },
  actions: {

    setUser({ commit }, dataSignIn) {
        commit('setUser', dataSignIn)
    },

    signUserIn({ commit, getters }, dataSignIn) {

        // console.log(router);
        // appMixins.methods.setGlobalUrl()
        // console.log(appMixins.methods.setGlobalUrl);
        // console.log(appMixins.data().vueUrl);
        // console.log(appMixins.data().vueUrl + 'users/gettoken'+dataSignIn.host+'?code='+dataSignIn.code);
        // console.log(dataSignIn);
        // console.log(commit);

        console.log("BAWAH NI TOKEN UNTUK LOGIN DI HELPER API");
        console.log(dataSignIn.code);

        if(appMixins.methods.vueUrlReturn() != undefined){
            

            console.log(appMixins.methods.vueUrlReturn() + 'users/gettoken'+dataSignIn.host+'?code='+dataSignIn.code);


            commit('setLoading', true)
            axios.get(appMixins.methods.vueUrlReturn() + 'users/gettoken'+dataSignIn.host+'?code='+dataSignIn.code)
            .then((response) => {
            //   console.log(response.data);

            commit('setLoading', false);
            commit('setUser', response.data);
            localStorage.setItem('pengguna', JSON.stringify(response.data));


                if(dataSignIn.host == "8080"){
                    router.push('/dashboard');
                }
                else{
                    window.location.assign(appMixins.methods.joomlaUrlReturn());
                }

            

            })
            .catch((error) => {
                console.log(error.response);
                commit('setLoading', false)
                // commit('setError', error.response)

                if(error.response.status == 400 || error.response.status == 401){
                    // this.$store.dispatch('signOut');
                    // this.signOut();
                    // let host = null;

                    if(location.host.includes("alami")){
                        host = "";
                    }
                    else if(location.host.includes("8080")){
                        host = "8080";
                    }
                    else if(location.host.includes("serasi")){
                        host = "serasi";
                    }

                    if(host == "8080"){

                    
                    let loginPortal8080 = "";
                    if(localStorage.localhostMyGEMSLogin != undefined){
                            if(localStorage.localhostMyGEMSLogin == 'jmg'){
                                loginPortal8080 = "https://mygems.jmg.gov.my/portal/sharing/rest/oauth2/authorize?client_id=MiW0HeUupa7Fxblz&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                                localStorage.clear()
                                window.location.assign(loginPortal8080)
                            }
                            else if(localStorage.localhostMyGEMSLogin == 'alami'){
                                loginPortal8080 = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                                localStorage.clear()
                                window.location.assign(loginPortal8080)
                            }
                    }
                    else{
                        localStorage.clear()
                        window.location.assign(appMixins.methods.joomlaUrlReturn())
                    }
                    }
                    else{
                        localStorage.clear()
                        window.location.assign(appMixins.methods.joomlaUrlReturn())
                    }

                    // localStorage.clear()
                    // commit('setUser', null)
                    // commit('setError', null)

                    // let loginPortal8080 = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                    // host == "8080"? window.location.assign(loginPortal8080) : window.location.assign('https://mygems.alami.my/portal/sharing/rest/oauth2/signout');
                }
            });


        }

        
    },

    signOut({ commit }) {
        

        let host = null;

        if(location.host.includes("jmg")){
            host = "";
        }
        else if(location.host.includes("alami")){
            host = "";
        }
        else if(location.host.includes("8080")){
            host = "8080";
        }
        else if(location.host.includes("serasi")){
            host = "serasi";
        }

        if(appMixins.methods.vueUrlReturn() != undefined){

            axios.get(appMixins.methods.vueUrlReturn() + 'users/logout?token='+this.getters.token, null, {  //renewjwt xperlu body, only header
                headers: {
                    Authorization: 'Bearer ' + this.getters.token,
                },
            })
            .then((response) => {
                
                commit('setUser', null)
                commit('setError', null)
    
                console.log(response.data);
    
                // let loginPortal8080 = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                    
                // host == "8080"? window.location.assign(loginPortal8080) : window.location.assign(this.loginPortalUrl);
                // host == "8080"? window.location.assign(loginPortal8080) : window.location.assign('https://mygems.alami.my/portal/sharing/rest/oauth2/signout?client_id=SEzwt9WquUQV8nSQ&redirect_uri=https://mygems.alami.my/geodatahub/?signout=1');
                
                if(host == "8080"){

                    
                    let loginPortal8080 = "";
                    if(localStorage.localhostMyGEMSLogin != undefined){
                        if(localStorage.localhostMyGEMSLogin == 'jmg'){
                            loginPortal8080 = "https://mygems.jmg.gov.my/portal/sharing/rest/oauth2/authorize?client_id=MiW0HeUupa7Fxblz&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                            localStorage.clear()
                            window.location.assign(loginPortal8080)
                        }
                        else if(localStorage.localhostMyGEMSLogin == 'alami'){
                            loginPortal8080 = "https://mygems.alami.my/portal/sharing/rest/oauth2/authorize?client_id=SEzwt9WquUQV8nSQ&display=default&response_type=code&redirect_uri=http://localhost:8080/&force_login=false&hideCancel=true&showSignupOption=true&canHandleCrossOrgSignIn=true&signuptype=esri";
                            localStorage.clear()
                            window.location.assign(loginPortal8080)
                        }
                    }
                    else{
                        localStorage.clear()
                        window.location.assign(appMixins.methods.joomlaUrlReturn())
                    }
                }
                else{
                    localStorage.clear()
                    window.location.assign(appMixins.methods.joomlaUrlReturn())
                }
                
    
                
    
            })
            .catch((error) => {
                console.log(error.response.status);
    
            })

        }

        

        

        // router.push('/').catch(()=>{});
    },

    clearError({ commit }) {
        commit('clearError')
    },

    checkUserLocalStorage({ commit, getters }) {
        const user = JSON.parse(localStorage.getItem('pengguna'))
        if (user) {
            commit('setUser', user)
        }
    },

    refreshToken({ state }) {


        if(appMixins.methods.vueUrlReturn() != undefined){

            return new Promise((resolve, reject) => {

                if(!state.user || !state.user.token){ 
                    // console.log('no token found'); 
                    return false; 
                }
                else {
    
                    axios.post(appMixins.methods.vueUrlReturn() + 'users/renewjwt', null, {  //renewjwt xperlu body, only header
                        headers: {
                            Authorization: 'Bearer ' + state.user.token,
                        },
                    })
                    .then((response) => {
    
                        // update token on user state
                        // update token on localstorage
                        // console.log(response.data.newjwt);
                        // console.log('token renew at '+new Date());
                        state.user.token = response.data.newjwt;  //get new jwt n put it in state
                        window._mycurrentjwt = state.user.token;  //_mycurrentjwt just for debug
    
                        if(localStorage.pengguna != undefined){
                            // JSON.parse(localStorage.pengguna).token = response.data.newjwt
                            localStorage.setItem('pengguna',JSON.stringify(response.data));
                            // console.log(JSON.parse(localStorage.pengguna));
                        }
    
                        resolve(response)
                    })
                    .catch((error) => {
                        // set user on state to null
                        // clear local storage
                        // sign out
                        console.log(error.response);
                        router.push('/').catch(()=>{})  //logout
                        // reject(error)
                    })
    
                    
                }
    
            })

        }
        
        
    },

  },
  getters: {

    user(state) {
        return state.user
    },

    token(state) {
        return state.user.token
    },

    error(state) {
        return state.error
    },

    loading(state) {
        return state.loading
    },

  },
}